import axios from 'axios';

function appendQuery(url, query) {
  if (query === '') {
    return url;
  }
  return (url + '&' + query).replace(/[&?]{1,2}/, '?');
}

function getSvg(url) {
  url = appendQuery(url, '_=' + Date.now());

  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(res => {
        if (res && (res.status === 200 || res.status === 304) && res.data) {
          resolve(res.data);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
}

function strToBase64(str) {
  return `data:image/svg+xml;base64,${window.btoa(str)}`;
}

async function svgHelper(url, opts = {}) {
  const res = await getSvg(url).catch(() => '');
  const str = res.replace(/<\?xml[^<>]*\?>/, '').replace(/<\!DOCTYPE[^<>]*>/, '');
  const base64 = strToBase64(str);

  if (typeof opts.cbk === 'function') {
    opts.cbk(base64);
  }
  return base64;
}

export default svgHelper;
